module.exports = __webpack_public_path__ + "static/img/banner_7.56adced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/banner_7.jpg
// module id = Hzg2
// module chunks = 19